const Input = ({ id, label, value, onChange,name, readOnly = false, style = {}, type = "text" , hasError = false, extraclass = "", divclass="mb-2" }) => (
  <div className={divclass}>
    <label htmlFor={id} className={`${!readOnly ? 'customBGwhiteBG txtcolor1' : "customBG txtcolor1"}`} style={{ fontSize: "0.8rem",padding:'0.1rem 0.3rem' }}>
      {label}
    </label>
    <input
      type={type}
      className={`form-control p-0 px-2 ${readOnly ? "custom-readonly" : ""} ${hasError ? "errorborder" : ""} ${extraclass}`}
      style={{ fontSize: "0.8rem", ...style }}
      id={id}
      name={name}
      placeholder={label} 
      value={value}
      onChange={onChange}
      disabled={readOnly}

    />
  </div>
);

export default Input;


